var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Component, Prop, CustomElement, Event, html, classMap } from '@sick-davinci/ce-decorators';
import { Icon } from '../icon/Icon';
import { IconRef } from '../icon/IconRef';
import { style } from './ToggleSwitch.style';
/**
 * A `davinci-toggle-switch` is used to switch between two states, such as turning a setting on or off.
 * Using mouse click, space- or enter-key to change the state
 * 
 * Style can be influenced using `icon-*` attributes.
 * @example
 * ```html
 * <davinci-toggle-switch checked></davinci-toggle-switch>
 * 
 * <davinci-toggle-switch
 *   icon-on="action/visibility"
 *   icon-off="action/visibility_off"
 * ></davinci-toggle-switch>
 * ```
 */

export let ToggleSwitch = (_dec = Component({
  style: [style],
  tag: 'davinci-toggle-switch',
  dependencies: [Icon, IconRef]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", Boolean), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", Boolean), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", Number), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", String), _dec10 = Prop(), _dec11 = Reflect.metadata("design:type", String), _dec12 = Prop(), _dec13 = Reflect.metadata("design:type", String), _dec14 = Prop(), _dec15 = Reflect.metadata("design:type", String), _dec16 = Prop(), _dec17 = Reflect.metadata("design:type", String), _dec18 = Prop(), _dec19 = Reflect.metadata("design:type", String), _dec20 = Event(), _dec21 = Reflect.metadata("design:type", Object), _dec(_class = (_class2 = class ToggleSwitch extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "checked", _descriptor, this);

    _initializerDefineProperty(this, "disabled", _descriptor2, this);

    _initializerDefineProperty(this, "tabindex", _descriptor3, this);

    _initializerDefineProperty(this, "value", _descriptor4, this);

    _initializerDefineProperty(this, "name", _descriptor5, this);

    _initializerDefineProperty(this, "iconOn", _descriptor6, this);

    _initializerDefineProperty(this, "iconOff", _descriptor7, this);

    _initializerDefineProperty(this, "iconOnSrc", _descriptor8, this);

    _initializerDefineProperty(this, "iconOffSrc", _descriptor9, this);

    _initializerDefineProperty(this, "change", _descriptor10, this);

    this.toggle = () => {
      if (!this.disabled) {
        this.checked = !this.checked;
        this.change.emit(this.checked);
      }
    };

    this._onKeyUp = event => {
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
        // browsers sends different keys
        this.toggle();
      }
    };
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('keyup', this._onKeyUp);
  }

  disconnectedCallback() {
    this.removeEventListener('keyup', this._onKeyUp);
    super.disconnectedCallback();
  }

  updateTabIndex() {
    this.tabIndex = this.disabled ? -1 : this.tabindex || 0;
  }

  render() {
    this.updateTabIndex();
    return html`
      <div
        class="container"
        @click=${this.toggle}
      >
        <div class="knob">
          ${this._renderIcon(false)}
          ${this._renderIcon(true)}
        </div>
      </div>
    `;
  }

  renderIconElement(iconPath, iconSrc) {
    if (iconSrc) {
      return html`<davinci-icon-ref src=${iconSrc}></davinci-icon-ref>`;
    }

    if (iconPath) {
      return html`<davinci-icon icon=${iconPath}></davinci-icon>`;
    }

    return null;
  }

  _renderIcon(isChecked) {
    const icon = isChecked ? this.renderIconElement(this.iconOn, this.iconOnSrc) : this.renderIconElement(this.iconOff, this.iconOffSrc);

    if (icon) {
      return html`
        <div class=${classMap({
        icon: true,
        iconOn: isChecked,
        iconOff: !isChecked,
        darkgrey: !this.disabled && !isChecked,
        grey: this.disabled
      })}>
          ${icon}
        </div>
      `;
    }

    return null;
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "checked", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "tabindex", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "value", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "name", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "iconOn", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "iconOff", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "iconOnSrc", [_dec16, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "iconOffSrc", [_dec18, _dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "change", [_dec20, _dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
